module.exports = __webpack_public_path__ + "static/bountifulbasementlogo-f3980b1502503c986862e72e074afcc9.png";